export default "__VITE_ASSET__Ackzkrs9__"